import React from 'react';

function _interpose(arr, sepElement) {
  return arr.reduce((acc, child, index) => {
    acc.push(child);
    if (index < arr.length - 1) {
      acc.push(
        React.cloneElement(sepElement, {
          key: `interpose-${index}-separator`,
        }),
      );
    }
    return acc;
  }, []);
}

export default function Interpose({
  children,
  separator,
  prefix = null,
  suffix = null,
}) {
  if (React.Children.count(children) === 0) {
    return null;
  }

  let result = [];

  if (prefix) {
    result.push(React.cloneElement(prefix, { key: `interpose-prefix` }));
  }

  result.push(..._interpose(React.Children.toArray(children), separator));

  if (suffix) {
    result.push(React.cloneElement(suffix, { key: `interpose-suffix` }));
  }

  return result;
}
